import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

export function useAccountData() {
  const [bookings, setBookings] = useState(null);
  const [profile, setProfile] = useState(null);
  const [pending, setPending] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [conversations, setConversations] = useState([]);

  const load = useCallback(() => {
    api.get("/my/bookings").then((r) => setBookings(r.data)).catch(() => setBookings([]));
    api.get("/profile/me").then((r) => setProfile(r.data)).catch(() => {});
    api.get("/my/reviews/pending").then((r) => setPending(r.data)).catch(() => {});
    api.get("/my/favorites").then((r) => setFavorites(r.data)).catch(() => {});
    api.get("/my/conversations").then((r) => setConversations(r.data)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  return { bookings, profile, pending, favorites, conversations, load };
}
